export default __webpack_public_path__ + "a53050e.png";